import { createAction } from "@reduxjs/toolkit";
import { LIMITS_FEATURE_KEY } from "@nxplatform/platform-entities/customer/limits";
import { CUSTOMER_NO_AUTH_FEATURE_KEY, CUSTOMER_FEATURE_KEY, USER_CONFIG_FEATURE_KEY, CUSTOMER_TOKEN_FEATURE_KEY, CUSTOMER_BET_HISTORY_FEATURE_KEY, CUSTOMER_PREFERENCES_FEATURE_KEY, ONDATO_VERIFICATION_FEATURE_KEY, BASIC_MODAL_FEATURE_KEY, GAMIXTER_FEATURE_KEY, TERMS_AND_POLICY_FEATURE_KEY, CASHOUT_FEATURE_KEY, SNACKBAR_NOTIFICATION_FEATURE_KEY } from "./shared-customer-feature-keys.js";
const customerForgotPasswordFailedClear = createAction(`${CUSTOMER_NO_AUTH_FEATURE_KEY}/customerForgotPasswordFailedClear`);
const setCustomerDisabledStatusCode = createAction(`${CUSTOMER_FEATURE_KEY}/SET_CUSTOMER_DISABLE_STATUS_CODE_ACTION`);
const customerWSTokenStart = createAction(
  `${CUSTOMER_FEATURE_KEY}/customerWSTokenStart`
);
const getCustomerWSToken = () => ({ type: customerWSTokenStart.type });
const clearTimeoutLimit = createAction(`${LIMITS_FEATURE_KEY}/clearTimeoutLimit`);
const getTimeoutLimitsStart = createAction(`${LIMITS_FEATURE_KEY}/getTimeoutLimitsStart`);
const toggleTimeoutLimitModalState = createAction(`${LIMITS_FEATURE_KEY}/toggleTimeoutLimitModalState`);
const clearLimitState = createAction(`${LIMITS_FEATURE_KEY}/clearLimitState`);
const updateCustomerLimitsStart = createAction(`${LIMITS_FEATURE_KEY}/updateCustomerLimitsStart`);
const limitsPeriodsStart = createAction(`${LIMITS_FEATURE_KEY}/limitsPeriodsStart`);
const getCustomerLimitsStart = createAction(`${LIMITS_FEATURE_KEY}/getCustomerLimitsStart`);
const getCustomerActiveLimitStart = createAction(`${LIMITS_FEATURE_KEY}/getCustomerActiveLimitStart`);
const disableCustomerLimitsStart = createAction(`${LIMITS_FEATURE_KEY}/disableCustomerLimitsStart`);
const createCustomerLimitsStart = createAction(`${LIMITS_FEATURE_KEY}/createCustomerLimitsStart`);
const createCustomerLimit = (payload) => ({ type: createCustomerLimitsStart.type, payload });
const disableCustomerLimit = (payload) => ({
  type: disableCustomerLimitsStart.type,
  payload
});
const getCustomerLimitById = (payload) => ({
  type: getCustomerActiveLimitStart.type,
  payload
});
const getCustomerLimits = () => ({ type: getCustomerLimitsStart.type });
const getLimitsPeriods = () => ({
  type: limitsPeriodsStart.type
});
const updateCustomerLimit = (payload) => ({
  type: updateCustomerLimitsStart.type,
  payload
});
const getTimeoutLimits = () => ({
  type: getTimeoutLimitsStart.type
});
const checkCustomerLimitTokenStart = createAction(`${LIMITS_FEATURE_KEY}/checkCustomerLimitTokenStart`);
const checkCustomerLimitToken = (payload) => ({
  type: checkCustomerLimitTokenStart.type,
  payload
});
const getCustomerStart = createAction(
  `${CUSTOMER_FEATURE_KEY}/getCustomerStart`
);
const customerData = () => ({
  type: getCustomerStart.type,
  meta: "secure"
});
const getUserConfigStart = createAction(
  `${USER_CONFIG_FEATURE_KEY}/getUserConfigStart`
);
const getUserConfig = () => ({
  type: getUserConfigStart.type
});
const getCustomerLastBetStart = createAction(
  `${CUSTOMER_FEATURE_KEY}/getCustomerLastBetStart`
);
const fetchLastBetSumData = () => ({
  type: getCustomerLastBetStart.type
});
const getCustomerFastAmountsStart = createAction(
  `${CUSTOMER_FEATURE_KEY}/getCustomerFastAmountsStart`
);
const fetchFastAmountsData = () => ({
  type: getCustomerFastAmountsStart.type
});
const sendSmarticoAction = createAction(`${CUSTOMER_FEATURE_KEY}/customerSendSmarticoAction`);
const customerSocketOpenSuccess = createAction(`${CUSTOMER_FEATURE_KEY}/customerSocketOpenSuccess`);
const getCustomerTokenSuccess = createAction(`${CUSTOMER_TOKEN_FEATURE_KEY}/getCustomerTokenSuccess`);
const getCustomerTokenStart = createAction(`${CUSTOMER_TOKEN_FEATURE_KEY}/getCustomerTokenStart`);
const getCustomerTokenFailure = createAction(`${CUSTOMER_TOKEN_FEATURE_KEY}/getCustomerTokenFailure`);
const getCustomerBetHistorySuccess = createAction(`${CUSTOMER_BET_HISTORY_FEATURE_KEY}/getCustomerBetHistorySuccess`);
const changeBalanceAccountSuccess = createAction(`${CUSTOMER_FEATURE_KEY}/changeBalanceAccountSuccess`);
const clearCustomerData = createAction(`${CUSTOMER_FEATURE_KEY}/clearCustomerData`);
const clearWebsocketHandledNotifications = createAction(`${CUSTOMER_FEATURE_KEY}/clearWebsocketHandledNotifications`);
const customerUpdateSuccess = createAction(`${CUSTOMER_FEATURE_KEY}/customerUpdateSuccess`);
const notifyAboutDeposit = createAction(`${CUSTOMER_FEATURE_KEY}/notifyAboutDeposit`);
const changeQuickBetSum = createAction(`${CUSTOMER_FEATURE_KEY}/changeQuickBetSum`);
const clearCustomerPreferences = createAction(`${CUSTOMER_PREFERENCES_FEATURE_KEY}/clearCustomerPreferences`);
const getCustomerPreferencesStart = createAction(`${CUSTOMER_PREFERENCES_FEATURE_KEY}/getCustomerPreferencesStart`);
const fetchCustomerPreferences = () => ({
  type: getCustomerPreferencesStart.type
});
const getCustomerAccountBalance = createAction(`${CUSTOMER_FEATURE_KEY}/getCustomerAccountBalance`);
const customerDepositError = createAction(`${CUSTOMER_FEATURE_KEY}/customerDepositError`);
const submitCashierForm = createAction(`${CUSTOMER_FEATURE_KEY}/submitCashierForm`);
const updateWidgetMaximizedState = createAction(`${CUSTOMER_FEATURE_KEY}/updateWidgetMaximizedState`);
const changeSmarticoInitStatus = createAction(`${CUSTOMER_NO_AUTH_FEATURE_KEY}/changeSmarticoInitStatus`);
const updateUserAccountSmarticoHashStart = createAction(`${CUSTOMER_FEATURE_KEY}/updateUserAccountSmarticoHashStart`);
const logoutCustomer = createAction(`${CUSTOMER_TOKEN_FEATURE_KEY}/logoutCustomer`);
const clearOnDatoVerificationState = createAction(`${ONDATO_VERIFICATION_FEATURE_KEY}/clearOnDatoVerificationState`);
const customerOpenBasicModalStart = createAction(`${BASIC_MODAL_FEATURE_KEY}/customerOpenBasicModalStart`);
const customerCloseBasicModal = createAction(`${BASIC_MODAL_FEATURE_KEY}/customerCloseBasicModal`);
const customerOpenBasicModal = (payload) => ({
  type: customerOpenBasicModalStart.type,
  payload
});
const triggerGamixterStart = createAction(`${GAMIXTER_FEATURE_KEY}/triggerGamixterStart`);
const triggerGamixter = (params) => ({
  type: triggerGamixterStart.type,
  payload: params
});
const changeCustomerBonusIssuance = createAction(`${CUSTOMER_FEATURE_KEY}/changeCustomerBonusIssuance`);
const changeBonusIssuanceStart = createAction(`${CUSTOMER_FEATURE_KEY}/changeBonusIssuanceStart`);
const getPrivacyPolicyStart = createAction(`${TERMS_AND_POLICY_FEATURE_KEY}/getPrivacyPolicyStart`);
const getTermsAndConditionsStart = createAction(`${TERMS_AND_POLICY_FEATURE_KEY}/getTermsAndConditionsStart`);
const getTimeZoneStart = createAction(`${CUSTOMER_PREFERENCES_FEATURE_KEY}/getTimeZoneStart`);
const getCustomerUpdatePreferencesStart = createAction(`${CUSTOMER_PREFERENCES_FEATURE_KEY}/getCustomerUpdatePreferencesStart`);
const changeCustomerOddsFormat = createAction(`${CUSTOMER_PREFERENCES_FEATURE_KEY}/changeCustomerOddsFormat`);
const fetchPrivacyPolicy = () => ({
  type: getPrivacyPolicyStart.type
});
const fetchTermsAndConditions = () => ({
  type: getTermsAndConditionsStart.type
});
const fetchTimeZoneList = () => ({ type: getTimeZoneStart.type });
const updateCustomerIssuranceStatus = (customer, value) => ({ type: changeBonusIssuanceStart.type, payload: { customer, value } });
const updateCustomerSettings = (form, noNotification = false) => ({
  type: getCustomerUpdatePreferencesStart.type,
  payload: { form, noNotification }
});
const customerUpdateStart = createAction(`${CUSTOMER_FEATURE_KEY}/customerUpdateStart`);
const customerSaveData = (customer, allowSuccessSnackbar = false, noNotification = false) => ({
  type: customerUpdateStart.type,
  payload: {
    customer,
    allowSuccessSnackbar,
    noNotification
  }
});
const updateCustomerEntityBonusType = createAction(`${CUSTOMER_FEATURE_KEY}/updateCustomerEntityBonusType`);
const submitCashoutStart = createAction(`${CASHOUT_FEATURE_KEY}/submitCashoutStart`);
const confirmShowed = createAction(`${CASHOUT_FEATURE_KEY}/confirmShowed`);
const submitCashout = (payload) => ({
  type: submitCashoutStart.type,
  payload
});
const activateSnackbarNotification = createAction(`${SNACKBAR_NOTIFICATION_FEATURE_KEY}/activateSnackbarNotification`);
const clearSnackbarNotificationState = createAction(`${SNACKBAR_NOTIFICATION_FEATURE_KEY}/clearSnackbarNotificationState`);
export {
  activateSnackbarNotification,
  changeBalanceAccountSuccess,
  changeBonusIssuanceStart,
  changeCustomerBonusIssuance,
  changeCustomerOddsFormat,
  changeQuickBetSum,
  changeSmarticoInitStatus,
  checkCustomerLimitToken,
  checkCustomerLimitTokenStart,
  clearCustomerData,
  clearCustomerPreferences,
  clearLimitState,
  clearOnDatoVerificationState,
  clearSnackbarNotificationState,
  clearTimeoutLimit,
  clearWebsocketHandledNotifications,
  confirmShowed,
  createCustomerLimit,
  createCustomerLimitsStart,
  customerCloseBasicModal,
  customerData,
  customerDepositError,
  customerForgotPasswordFailedClear,
  customerOpenBasicModal,
  customerOpenBasicModalStart,
  customerSaveData,
  customerSocketOpenSuccess,
  customerUpdateStart,
  customerUpdateSuccess,
  customerWSTokenStart,
  disableCustomerLimit,
  disableCustomerLimitsStart,
  fetchCustomerPreferences,
  fetchFastAmountsData,
  fetchLastBetSumData,
  fetchPrivacyPolicy,
  fetchTermsAndConditions,
  fetchTimeZoneList,
  getCustomerAccountBalance,
  getCustomerActiveLimitStart,
  getCustomerBetHistorySuccess,
  getCustomerFastAmountsStart,
  getCustomerLastBetStart,
  getCustomerLimitById,
  getCustomerLimits,
  getCustomerLimitsStart,
  getCustomerPreferencesStart,
  getCustomerStart,
  getCustomerTokenFailure,
  getCustomerTokenStart,
  getCustomerTokenSuccess,
  getCustomerUpdatePreferencesStart,
  getCustomerWSToken,
  getLimitsPeriods,
  getPrivacyPolicyStart,
  getTermsAndConditionsStart,
  getTimeZoneStart,
  getTimeoutLimits,
  getTimeoutLimitsStart,
  getUserConfig,
  getUserConfigStart,
  limitsPeriodsStart,
  logoutCustomer,
  notifyAboutDeposit,
  sendSmarticoAction,
  setCustomerDisabledStatusCode,
  submitCashierForm,
  submitCashout,
  submitCashoutStart,
  toggleTimeoutLimitModalState,
  triggerGamixter,
  triggerGamixterStart,
  updateCustomerEntityBonusType,
  updateCustomerIssuranceStatus,
  updateCustomerLimit,
  updateCustomerLimitsStart,
  updateCustomerSettings,
  updateUserAccountSmarticoHashStart,
  updateWidgetMaximizedState
};
